import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useBranchOfficeStore } from "../../hooks/useBranchOfficeStore";
import { BranchOfficeModal } from "./components/BranchOfficeModal";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'typeOffice', label: 'Tipo', align:'center' },
    { type: 'text', field: 'phone', label: 'Teléfono', align:'center' },
    { type: 'text', field: 'district', label: 'Comuna', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const BranchOfficesView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionBranchOffice, getBranchOffice, getBranchOfficeByCompany, deleteBranchOffice } = useBranchOfficeStore();

    const [loading, setLoading] = useState(false);
    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getBranchOfficeApi()
    },[])

    const getBranchOfficeApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getBranchOfficeByCompany(search);
            if(!response){
                setBranchOffices([]);
                setLoading(false);
                return false;
            }else{
                setBranchOffices(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionBranchOffice('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionBranchOffice('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionBranchOffice('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionBranchOffice('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteBranchOffice(rowSelected.id)
            if(response){
                getBranchOfficeApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getBranchOfficeApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Sucursales'}
                    columns={columns} 
                    loading={loading}
                    rows={branchOffices || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nueva sucursal'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <BranchOfficeModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        branchofficeSelected = {rowSelected}
                        listBranchoffices = {getBranchOfficeApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}